module.exports = __webpack_public_path__ + "img/nav.34a1232b.png";